var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container pad30 maxW700 row align-items-center m-auto"},[_c('div',{staticClass:"col-sm-12"},[_c('h1',{staticClass:"mb30 text-center"},[_vm._v(_vm._s(_vm.$t("404")))])])])}
var staticRenderFns = []

export { render, staticRenderFns }